/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Spaces_Outlook_ReceivedInputs */



/**
* | output |
* | --- |
* | "Received {date}" |
*
* @param {Spaces_Outlook_ReceivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_outlook_received = /** @type {((inputs: Spaces_Outlook_ReceivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Outlook_ReceivedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Empfangen ${i?.date}`)
	return /** @type {LocalizedString} */ (`Received ${i?.date}`)
});